// This function checks whether the nav link corresponds to the
// current active path for the purpose of highlighting it.
export const checkIsActivePath = ({ currentPathname, href }) => {
  if (!currentPathname || !href) {
    return false;
  }

  return currentPathname === href || currentPathname.indexOf(href) > -1;
};
